/**
 * Dashboard Page (Web)
 * Main dashboard after authentication
 */

import { Fragment } from 'react';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function DashboardPage() {
  return (
    <AuthenticatedLayout>
      <Fragment />
    </AuthenticatedLayout>
  );
}

